import { Button } from '@abyss/web/ui/Button';
import { Link } from '@abyss/web/ui/Link';
import { Markdown } from '@abyss/web/ui/Markdown';
import { Text } from '@abyss/web/ui/Text';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledFontSizeModal } from './FontSizeModal.style';

export const FontSizeModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleClose = () => {
    setIsOpen(false);

    // Focus back on the link after closing the modal
    setTimeout(() => {
      linkRef.current?.focus();
    }, 0);
  };
  const { t } = useTranslation();

  const footer = (
    <Button
      data-testid="font-size-modal-close-button"
      onClick={handleClose}
      variant="solid"
    >
      {t('FONT_SIZE_CONTENT.CloseButton')}
    </Button>
  );

  return (
    <>
      <Link
        css={{
          fontSize: '$sm',
          color: '#196ECF',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
        data-testid="font-size-link"
        onClick={() => {
          setIsOpen(true);
        }}
        ref={linkRef}
      >
        {t('FONT_SIZE')}
      </Link>
      {isOpen && (
        <StyledFontSizeModal
          closeOnClickOutside={false}
          data-testid="font-size-modal"
          footer={footer}
          header={t('FONT_SIZE_CONTENT.Title')}
          isOpen={isOpen}
          onClose={handleClose}
          size="$sm"
        >
          <Text data-testid="font-size-modal-content">
            <Markdown>{t('FONT_SIZE_CONTENT.Content')}</Markdown>
          </Text>
        </StyledFontSizeModal>
      )}
    </>
  );
};

export default FontSizeModal;
